import NoData from '@/components/NoData.vue';
<template>
  <div class="table-content">
    <div class="table" v-if="tableData.length">
      <table class="table-wrap">
        <tr class="tr-head">
          <td
            v-for="(title, index) in tableField"
            :key="index"
            :class="{ 'hidden-td': index == 1, 'fixed-td': index == 0 }"
          >
            <p class="tr-title" @click="showPop(title.explain)">
              <span class="th-title"> {{ title.label }}</span>
              <img
                class="th-img"
                v-if="title.explain"
                src="@/assets/images/icon_help.png"
              />
            </p>
            <p
              class="explain-txt"
              :class="[isShowExplain ? 'show-pop' : 'hide-pop']"
              v-if="explainTxt == title.explain"
            >
              {{ explainTxt }}
            </p>
          </td>
        </tr>
        <tr v-for="table in tableData" :key="table.id">
          <td
            v-for="(item, i) in tableField"
            :key="i"
            :class="{ 'hidden-td': i == 1, 'fixed-td': i == 0 }"
          >
            <template v-if="item.prop == 'operation'">
              <p
                class="btn-detail"
                v-if="$route.path.includes('/data')"
                @click="viewWorkDetailFn(table)"
              >
                查看详情
              </p>
              <router-link
                v-else
                class="btn-detail"
                :to="{
                  path: '/income/withdrawDetail',
                  query: { id: table.id, money_type: table.money_type },
                }"
                >详情</router-link
              >
              <!-- <p class="btn-detail" v-else @click="viewBillDetail(table)">
                详情
              </p> -->
            </template>
            <template>
              <!-- 状态值/货币类型/收益来源/贡献点3位/订单号不变/其他数字类型2位 -->
              <p v-if="item.prop == 'state'">
                {{ table[item.prop] | regroupState }}
              </p>
              <p v-else-if="item.prop == 'money_type'">
                {{ table[item.prop] | regroupMoneyType }}
              </p>
              <p v-else-if="item.prop == 'income_type'">
                {{
                  table[item.prop] | regroupIncomeType(table['income_descr'])
                }}
              </p>
              <p v-else-if="item.prop == 'contribution'">
                {{ table[item.prop] | regroupComma(3) }}
              </p>
              <p v-else-if="item.prop == 'time'">
                {{ table[item.prop] | regroupDate }}
              </p>
              <p v-else-if="item.prop == 'id'">{{ table[item.prop] }}</p>
              <p v-else-if="table.money_type && table.money_type == 1">
                {{ table[item.prop] | regroupComma(3) }}
              </p>
              <p v-else>{{ table[item.prop] | regroupComma(2) }}</p>
            </template>
          </td>
        </tr>
      </table>
    </div>
    <NoData v-if="showDefaultImg"></NoData>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue';
export default {
  components: {
    NoData,
  },
  props: {
    tableField: {
      type: Array,
      default: () => {},
    },
    tableData: {
      type: Array,
      default: () => {},
    },
    closePop: {
      type: Number,
      default: 0,
    },
    activeType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShowExplain: false,
      explainTxt: '',
      showDefaultImg: false,
    };
  },
  watch: {
    closePop(val) {
      if (val) {
        this.isShowExplain = false;
      }
    },
    tableData(val) {
      val.length ? (this.showDefaultImg = false) : (this.showDefaultImg = true);
    },
  },
  filters: {
    regroupComma(val, num) {
      if (typeof val == 'number') {
        if (val.toString().includes('.')) {
          let reg = /(\d)(?=(\d{3})+\.)/g;
          return val.toFixed(num).toString().replace(reg, '$1,');
        } else {
          let reg = /(\d)(?=(?:\d{3})+$)/g;
          return val.toString().replace(reg, '$1,');
        }
      } else {
        return val;
      }
    },
    regroupState(val) {
      let stateTxt = '';
      switch (val) {
        case 100:
          stateTxt = '待审核';
          break;
        case 101:
        case 102:
          stateTxt = '待打款';
          break;
        case 200:
          stateTxt = '打款成功';
          break;
        case 300:
          stateTxt = '审核失败';
          break;
        case 301:
        case 400:
          stateTxt = '打款失败';
          break;

        default:
          break;
      }
      return stateTxt;
    },
    regroupMoneyType(val) {
      let moneyTypeTxt = '';
      switch (val) {
        case 1:
          moneyTypeTxt = '贡献点';
          break;
        case 2:
          moneyTypeTxt = '迷你豆';
          break;
        case 3:
          moneyTypeTxt = '广告';
          break;
        case 4:
          moneyTypeTxt = '迷你点';
          break;
        case 5:
          moneyTypeTxt = '其他';
          break;
        default:
          break;
      }
      return moneyTypeTxt;
    },
    regroupIncomeType(val, desc) {
      let incomeTypeTxt = '';
      switch (val) {
        case 1:
          incomeTypeTxt = '地图';
          break;
        case 2:
          incomeTypeTxt = '资源';
          break;
        case 3:
          incomeTypeTxt = desc;
          break;
        default:
          break;
      }
      return incomeTypeTxt;
    },
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  methods: {
    showPop(txt) {
      if (txt) {
        this.isShowExplain = true;
        this.explainTxt = txt;
      }
    },
    // 跳转作品详情页
    viewWorkDetailFn(row) {
      this.$emit('mapDetailsClick', sessionStorage.getItem('activeLabel'));
      this.$router.push({ path: '/charts/map-detail', query: { id: row.id } });
    },
    // 查看提现记录详情
    viewBillDetail(row) {
      this.detailInfo = row;
      this.openBillDialog = true;
    },
  },
};
</script>
<style lang="less" scoped>
.table-wrap {
  font-size: 24px;
  width: 100%;
  border: 1px solid #d9d9d9;
  tr:nth-child(odd) {
    background: #fafafa;
  }
  tr:nth-child(even) {
    background: #fff;
  }

  td {
    display: inline-block;
    width: 200px;
    line-height: 88px;
    text-align: center;
    position: relative;
  }
  tr {
    td:nth-child(1) {
      padding-left: 10px;
      line-height: 88px;
      position: absolute;
      border-left: 1px solid#d9d9d9;
      margin-left: -2px;
    }
    .hidden-td {
      padding-left: 140px;
    }
  }
  tr:nth-child(odd) {
    .fixed-td {
      background: #fafafa;
    }
  }
  tr:nth-child(even) {
    .fixed-td {
      background: #fff;
    }
  }
  .fixed-td {
    z-index: 100;
  }
  .tr-head {
    border-bottom: 1px solid #d9d9d9;
    .tr-title {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8c8c8c;
      img {
        display: block;
        width: 20px;
        height: 20px;
        margin-left: 5px;
        margin-top: -5px;
      }
    }
  }

  .explain-txt {
    position: absolute;
    top: 90px;
    background: rgba(0, 0, 0, 0.6);
    white-space: pre-wrap;
    text-align: justify;
    color: #fff;
    padding: 5px;
    line-height: 1.5;
    font-size: 24px;
  }
  .show-pop {
    display: block;
  }
  .hide-pop {
    display: none;
  }
  .btn-detail {
    color: #2b6ddf;
    text-decoration: underline;
    font-weight: 600;
  }
}

.table {
  width: 100%;
  margin-top: 23px;
  white-space: nowrap;
  overflow-x: scroll;
  margin-bottom: 20px;
}
</style>
